export interface JobCategory {
	value: string
	label: string
}

export const jobTypes = ['Permanent', 'Contract', 'Temporary'];
export const salaryTypes = ['Annual', 'Monthly', 'Weekly', 'Daily', 'Hourly'];
export const jobCategories = [
	{ value: 'architecture', label: 'Architecture' },
	{ value: 'back-end-development', label: 'Back End Development' },
	{ value: 'business-analyst', label: 'Business Analyst' },
	{ value: 'cloud-infrastructure', label: 'Cloud Infrastructure' },
	{ value: 'data-analytics-ai', label: 'Data/Analytics/AI' },
	{ value: 'fintech', label: 'FinTech' },
	{ value: 'front-end-development', label: 'Front End Development' },
	{ value: 'full-stack-development', label: 'Full Stack Development' },
	{ value: 'mobile-development', label: 'Mobile Development' },
	{ value: 'network-infrastructure', label: 'Network Infrastructure' },
	{ value: 'product-management', label: 'Product Management' },
	{ value: 'project-programme-management', label: 'Project/Programme Management' },
	{ value: 'ui-ux', label: 'UI/UX' },
	{ value: 'vr-ar', label: 'VR/AR' }
];
